import { GET_BRAINCHIP_TYPES_LOADING, GET_BRAINCHIP_TYPES_SUCCESS } from '../actionTypes';
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';

export const getBrainchipTypesSuccess = payload => {
    return ({
        type: GET_BRAINCHIP_TYPES_SUCCESS,
        payload
    })
}

export const getBrainchipTypesAsync = payload => dispatch => {
    return client.service('brainchip-types').find()
		.then((response) => {
            console.log('got!', response);
            dispatch(getBrainchipTypesSuccess(response));
            return response
		})
        .catch((error) => {
            console.error('error', error);
        })
           
}